import { View } from "react-native";
import { useTheme } from "../../../hooks/use-theme";
import Icon from "../../Icon";
import MarkdownView from "../../MarkdownView";
import Gap from "../../../ui_atoms/Gap";

type CheckItemProps = {
    markdown: string;
};

export const CheckItem = ({ markdown }: CheckItemProps) => {
    const { colors } = useTheme();

    return (
        <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
            <Icon name="check-circle-heavy" size={20} color={colors.secondary} style={{ top: 7 }} />
            <Gap gap={0.25} />
            <MarkdownView markdown={markdown} style={{ flex: 1 }} allowFontScaling={false} />
        </View>
    );
};
